import { TenantContext } from '@/components';
import { SortDirection } from '@/components/Table/types';
import { processesRepo } from '@/constants/providers';
import { DataWithPagination } from '@/shared/types';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { Process } from '../domain';
import { ProcessKey } from './keys';

export const useGetProcessesByOrganization = (
  organizationId: number,
  pageNumber?: number,
  filter?: string,
  sortBy?: string,
  sortOrder?: SortDirection,
  options?: UseQueryOptions<DataWithPagination<Process[]>>,
) => {
  const { currentSelectedTenant } = useContext(TenantContext);
  return useQuery<DataWithPagination<Process[]>>(
    [
      ...ProcessKey.BY_ORGANIZATION_PAGED(organizationId, {
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      }),
      currentSelectedTenant?.id,
    ],
    () =>
      processesRepo.getProcessesByOrganization(
        organizationId,
        pageNumber,
        filter,
        sortBy,
        sortOrder,
      ),
    options,
  );
};
